import React, { useContext, useState } from 'react'
import { Formik } from 'formik'
import { Button, Form, Grid, GridCell, NotificationInline, NotificationManagerContext,
   Spacer, Text, View } from 'oio-react'
import { VisibilityIcon } from 'assets/icons'
import { adminUrl } from 'config/constants/urls'
import { Textarea } from 'src/components/ConnectedForm'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization, useUpdateOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

const ExploreSettings = () => {
   const [error, setError] = useState(null)
   const { showNotification } = useContext(NotificationManagerContext)
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()
   const { updateOrganization, mutating } = useUpdateOrganization()

   const handleUpdateOrganization = async (values, actions) => {
      try {
         await updateOrganization(values)

         showNotification({
            message: 'Explore App saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         setError(err?.graphQLErrors?.map(e => e.message).join(', ') || err.message)
      } finally {
         actions.setSubmitting(false)
      }
   }

   return (
      <Formik
         initialValues={{ exploreDescription: organization.exploreDescription }}
         onSubmit={handleUpdateOrganization}
         render={({ handleSubmit, isSubmitting }) => (
            <Form
               elementAppearance="plain"
               elementBackgroundColor="#eee"
               elementFocusBackgroundColor="#f3f3f3"
               onSubmit={handleSubmit}>
               <ProtoReturnBar
                  display="block[a-c] none[d-f]"
                  returnLinkName="Admin Workspace"
                  returnLinkTo={adminUrl}
               />
               <View display="flex" justifyContent="center">
                  <View
                     width="100%"
                     maxWidth="100%[a-c] 600px[d-f]"
                     padding="40px 20px">
                     <View
                        width="100%"
                        display="flex"
                        flexFlow="column[a-c] row[d-f]">
                        <View flex="1 1 auto" paddingRight="30px[b-f]">
                           <ProtoHeadingBlock
                              title="Explore"
                              description="Edit description for the Explore Page"
                           />
                        </View>
                        <View display="flex" flex="0 0 auto" paddingTop="10px">
                           <Button
                              linkTo="/explore"
                              name="View"
                              color="#ddd"
                              textColor="#333"
                              size="md"
                              textSize="0.9"
                              padding="15px">
                              <View display="flex" alignItems="center" marginRight="5px">
                                 <VisibilityIcon
                                    width="16px"
                                    height="16px"
                                    color="#333"
                                    strokeWidth="2px"
                                 />
                              </View>
                           </Button>
                           <Spacer orientation="vertical" size="1" />
                           <Button
                              type="submit"
                              name="Save Changes"
                              mode={mutating ? 'loading' : 'normal'}
                              color={theme.protoSettingsHighlightBackgroundColor}
                              textColor={theme.protoSettingsHighlightForegroundColor}
                              textWeight="medium"
                              size="md"
                              textSize="0.9"
                              padding="25px"
                           />
                        </View>
                     </View>
                     <Spacer size="4" />
                     {error && (
                        <NotificationInline
                           borderRadius="3px"
                           textSize="2"
                           type="error"
                           title="Error"
                           message={error.graphQLErrors.map(e => e.message).join(', ') || error.message}
                        />
                     )}
                     <View
                        width="100%"
                        padding="20px 20px 15px 20px"
                        borderRadius="3px"
                        backgroundColor="#fff">
                        <Grid spacing="10px">
                           <GridCell colspan="4">
                              <Text size="2" weight="medium">
                                 Description
                              </Text>
                           </GridCell>
                           <GridCell colspan="8">
                              <Textarea
                                 rows="10"
                                 size="sm"
                                 name="exploreDescription"
                              />
                           </GridCell>
                        </Grid>
                     </View>
                     <Spacer size="6" />
                  </View>
               </View>
            </Form>
         )}
      />
   )
}

export default ExploreSettings
